import React from 'react';
import Dropdown from 'components/dropdown';
import { BsThreeDots } from 'react-icons/bs';
import { BsThreeDotsVertical } from 'react-icons/bs';

function CardMenu(props) {
  const { transparent, vertical, setItemsPerPage } = props; // Receive setItemsPerPage function as prop
  const [open, setOpen] = React.useState(false);
  return (
    <Dropdown
      button={
        <button
          onClick={() => setOpen(!open)}
          className={`flex items-center text-xl hover:cursor-pointer ${
            transparent
              ? 'bg-none text-white hover:bg-none active:bg-none'
              : vertical
              ? 'bg-none text-navy-700 dark:text-white'
              : 'bg-lightPrimary p-2 text-brand-500 hover:bg-gray-100 dark:bg-navy-700 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/10'
          } linear justify-center rounded-lg font-bold transition duration-200`}
        >
          {vertical ? (
            <p className="text-[24px] hover:cursor-pointer">
              <BsThreeDotsVertical />
            </p>
          ) : (
            <BsThreeDots className="h-6 w-6" />
          )}
        </button>
      }
      animation={'origin-top-right transition-all duration-300 ease-in-out'}
      classNames={`${transparent ? 'top-8' : 'top-11'} right-0 w-max`}
      children={
        <div className="z-50 w-max rounded-xl bg-white px-4 py-3 text-sm shadow-xl shadow-shadow-500 dark:!bg-navy-700 dark:shadow-none">
          {/* Show options for number of data entries */}
          <p
            className="hover:text-black flex cursor-pointer items-center gap-2 text-gray-600 hover:font-medium"
            onClick={() => setItemsPerPage(10)} // Set items per page to 10 when clicked
          >
            10 per page
          </p>
          <p
            className="hover:text-black mt-2 flex cursor-pointer items-center gap-2 pt-1 text-gray-600 hover:font-medium"
            onClick={() => setItemsPerPage(20)} // Set items per page to 20 when clicked
          >
            20 per page
          </p>
          <p
            className="hover:text-black mt-2 flex cursor-pointer items-center gap-2 pt-1 text-gray-600 hover:font-medium"
            onClick={() => setItemsPerPage(30)} // Set items per page to 30 when clicked
          >
            30 per page
          </p>
        </div>
      }
    />
  );
}

export default CardMenu;
